export default __webpack_public_path__ + "da475bc55f5b50a6b50528663b924dd1.png";